<full-calendar [options]="calendarOptions()" />
